import React from 'react';
import DemoFrame from './DemoFrame';
import useDemoPlayer, { typingDuration, useTypedText } from './useDemoPlayer';
import { DEMO_PPT } from './demoFixtures';

const P = DEMO_PPT;

// 0 슬라이드 → 1 제목을 눌러 고치기 시작 → 2 새 제목 입력 → 3(완성) 저장 알림
const STEPS = [1200, 700, typingDuration(P.after, 1, 110, 500)];

const PointerIcon = () => (
  <svg viewBox="0 0 24 24" width="18" height="18" aria-hidden="true">
    <path d="M5 3l14 8-6 1.5L10 19z" fill="#191f28" stroke="#ffffff" strokeWidth="1.5" strokeLinejoin="round" />
  </svg>
);

const PptEditDemo = ({ surface = 'home', title = 'AI PPT', autoStart = false }) => {
  const player = useDemoPlayer({ steps: STEPS, surface, feature: 'ppt_edit', autoStart });
  const { phase, done, paused } = player;
  const typed = useTypedText(P.after, { active: phase === 2, complete: phase > 2, paused, charsPerTick: 1, tickMs: 110 });
  const editing = phase === 1 || phase === 2;
  const heading = phase < 2 ? P.before : typed;

  return (
    <DemoFrame title={title} player={player}>
      <div className="wqdemo-slide">
        <div>
          <p className="wqdemo-slide-kicker">{P.kicker}</p>
          <h4 className={`wqdemo-slide-title${editing ? ' is-editing' : ''}`}>
            {heading}
            {phase === 2 && <span className="wqdemo-cursor" />}
          </h4>
          <ul>
            {P.bullets.map((b) => <li key={b}>{b}</li>)}
          </ul>
        </div>
        <img className="wqdemo-slide-art" src={P.image} alt="" loading="lazy" />
        {!done && (
          <span
            className="wqdemo-pointer"
            style={phase === 0 ? { left: '70%', top: '80%' } : { left: '26%', top: '32%' }}
          >
            <PointerIcon />
          </span>
        )}
      </div>
      <div className="wqdemo-thumbs" aria-hidden="true">
        <span className="wqdemo-thumb-current" />
        {P.thumbs.map((src) => <img key={src} src={src} alt="" loading="lazy" />)}
      </div>
      {done ? (
        <div className="wqdemo-toast wqdemo-in">
          <span>1쪽을 고쳤어요</span>
          <span>되돌리기</span>
        </div>
      ) : (
        <div className="wqdemo-toast is-hint">
          <span>글자를 눌러 바로 고칠 수 있어요</span>
        </div>
      )}
    </DemoFrame>
  );
};

export default PptEditDemo;
